export const METER_PER_KILOMETER = 1000;
